<template>
  <v-card :class="['bottom-sheet', { active: show ? true : false }]">
    <v-icon @click="$emit('close')" class="closeBtn">keyboard_backspace</v-icon>
    <div class="bottom-sheet-head">
      <h3>
        <flag class="flag" :iso="selectedProfile.nationality" />
        {{ selectedProfile.name }}
      </h3>
    </div>
    <div class="profile">
      <ScoutData :userData="selectedProfile" />

      <v-tabs fixed-tabs background-color="white" slider-color="light-green accent-4">
        <v-tab href="#Scoutdaten">Scoutdaten</v-tab>
        <v-tab href="#Scouted">Gescoutet</v-tab>
        <v-tab href="#Gallery">Galerie</v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item :value="'Scoutdaten'">
            <div class="overview-profile" flat>
              <div class="flex-row-wrap">
                <div>
                  <label>Sprachen</label>
                  <div
                    class="no-margin"
                    v-for="(language, i) in selectedProfile.languages"
                    :key="i"
                  >
                    {{ language }}
                  </div>
                </div>
              </div>
              <v-list>
                <v-list-group no-action>
                  <template v-slot:activator>
                    <h3>Mehr Infos</h3>
                  </template>

                  <div>
                    <div class="history-content">
                      <div class="flex-row-wrap">
                        <div>
                          <label>Geburtsort</label>
                          {{ selectedProfile.birthplace }}
                        </div>
                        <div v-if="selectedProfile.living_in_country">
                          <label>Bundesland</label>
                          {{ selectedProfile.living_in_state }}
                        </div>
                      </div>
                    </div>
                  </div>
                </v-list-group>
              </v-list>
            </div>
          </v-tab-item>
          <v-tab-item :value="'Scouted'">
            <div class="overview-career" flat>
              <v-timeline
                v-if="selectedProfile.history && selectedProfile.history.length > 0"
              >
                <v-timeline-item
                  v-for="(history, i) in selectedProfile.history"
                  :key="i"
                  color="light-green accent-4"
                  :right="i % 2 === 0"
                  :left="i % 2 === 1"
                  small
                >
                  <HistoryCard :history="history" :side="i"></HistoryCard>
                </v-timeline-item>
              </v-timeline>
              <div v-else class="history-content">
                <h3>Bisher keine Talente angegeben.</h3>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item :value="'Gallery'">
            <v-card class="overview-career" flat>
              <div class="overview-profile" flat>
                <div class="history-content">
                  <GalleryContent
                    v-if="hasPictures"
                    :images="selectedProfile.galleryImages"
                  />
                  <div v-else class="history-content">
                    <h3>Bisher keine Galerie angelegt.</h3>
                  </div>

                  <LinkCard
                    v-if="hasLinks"
                    :links="selectedProfile.videolinks"
                    :title="'Videos'"
                  />
                  <LinkCard
                    v-if="hasArticles"
                    :links="selectedProfile.newslinks"
                    :title="'Zeitungsartikel'"
                  />
                </div>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-card>
</template>

<script>
import GalleryContent from '@/components/settings/GalleryContent';
import LinkCard from '@/components/settings/LinkCard';
import ScoutData from '../profile/ScoutData';
import match from '../../mixins/match';
import common from '../../mixins/common';

export default {
  name: 'scout-sheet',

  components: {
    GalleryContent,
    LinkCard,
    ScoutData,
  },

  mixins: [match, common],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selectedProfile: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    tab: null,
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.settings-wrapper {
  padding-top: 60px;
  overflow: hidden;
}
</style>
